import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { db, firebase } from '../firebase/Firebase'
//import { Route } from 'react-router-dom'
//import StudentReport from './reports/StudentReport'
import '../styles/GlobalStyle.css'
import CustomFooter from '../login/CustomFooter'
//import { db } from '../firebase/Firebase'
//import { getURLSplitArray } from '../Util'
import ColType from '../Types'
import { Col, Layout, Row, Button } from 'antd'
import { flattenDoc, getAssessmentDisplayName, getCurrentYear, getIconFromMainSubject, getIDFromURL, getQueryStringParam, getWeekInQuarter, injectBaseHref, isTestingTimeRangeExpired } from '../Util'
import AssessmentSurveyForm from '../teacher/pacingguide/AssessmentSurveyForm'
import StudentResource from '../teacher/pacingguide/StudentResource'
const Content = Layout.Content
const moment = require('moment')


class StudentPracticeResource extends Component {
    state = {
        resourceId: '',
        quizId: '',
    }

    componentDidMount() {
        document.title = 'My Practice - Dot It'
        window.scrollTo(0, 0)

        let studentId = '';
        let pathSplit = this.props.location.pathname.split('/');
        if (pathSplit.length > 3) {
            studentId = pathSplit[3];
        }
        const resourceId = getQueryStringParam('resource');
        const quizId = getQueryStringParam('quiz');

        this.setState({
            resourceId: resourceId,
            quizId: quizId,
        });

        if (studentId &&
            Object.keys(this.props.studentBaseProps.resourcesDict).length === 0 &&
            Object.keys(this.props.studentBaseProps.quizzesDict).length === 0) {
            // go to /practice, do not have resources or quizzes yet,
            // this only happens on page reload for this resource or quiz.
            this.props.history.push('/student/practice/' + studentId);
        }
    }

    getResourceId = () => {
        if (this.state.resourceId) {
            return this.state.resourceId;
        }
        if (this.state.quizId) {
            return this.state.quizId;
        }
        return '';
    }

    getResourceProgressDocId = () => {
        let docId = this.getResourceId();
        if (!docId) {
            return '';
        }
        if (!(this.props.studentBaseProps && this.props.studentBaseProps.student)) {
            return '';
        }
        docId = this.props.studentBaseProps.student.id + '-' + docId;
        return docId;
    }

    getStandards = () => {
        if (this.state.resourceId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.resourcesDict &&
            this.props.studentBaseProps.resourcesDict.hasOwnProperty(this.state.resourceId)
        ) {
            return [this.props.studentBaseProps.resourcesDict[this.state.resourceId].standard.standard];
        } else if (this.state.quizId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.quizzesDict &&
            this.props.studentBaseProps.quizzesDict.hasOwnProperty(this.state.quizId)
        ) {
            return this.props.studentBaseProps.quizzesDict[this.state.quizId].standards
        }

        return [];
    }

    getStandard = () => {
        if (this.state.resourceId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.resourcesDict &&
            this.props.studentBaseProps.resourcesDict.hasOwnProperty(this.state.resourceId)
        ) {
            return this.props.studentBaseProps.resourcesDict[this.state.resourceId].standard.standard;
        } else if (this.state.quizId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.quizzesDict &&
            this.props.studentBaseProps.quizzesDict.hasOwnProperty(this.state.quizId) &&
            this.props.studentBaseProps.quizzesDict[this.state.quizId].standards.length > 0
        ) {
            return this.props.studentBaseProps.quizzesDict[this.state.quizId].standards[0];
        }
        return '';
    }

    getStandardNameAndCategory = () => {
        if (this.state.resourceId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.resourcesDict &&
            this.props.studentBaseProps.resourcesDict.hasOwnProperty(this.state.resourceId)
        ) {
            let standard = { state: '', standard: '', standardName: '', standardCategory: '' };
            standard.standard = this.props.studentBaseProps.resourcesDict[this.state.resourceId].standard.standard;
            standard.standardName = this.props.studentBaseProps.resourcesDict[this.state.resourceId].standard.standardName;
            standard.standardCategory = this.props.studentBaseProps.resourcesDict[this.state.resourceId].standard.standardCategory;
            standard.state = this.props.studentBaseProps.resourcesDict[this.state.resourceId].state;
            return standard;
        } else if (this.state.quizId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.quizzesDict &&
            this.props.studentBaseProps.quizzesDict.hasOwnProperty(this.state.quizId) &&
            this.props.studentBaseProps.quizzesDict[this.state.quizId].standards.length > 0
        ) {
            let standard = { state: '', standard: '', standardName: '', standardCategory: '' };
            standard.standard = this.props.studentBaseProps.quizzesDict[this.state.quizId].standards[0];
            standard.standardName = this.props.studentBaseProps.quizzesDict[this.state.quizId].standardName;
            standard.standardCategory = this.props.studentBaseProps.quizzesDict[this.state.quizId].standardCategory;
            standard.state = this.props.studentBaseProps.quizzesDict[this.state.quizId].state;
            return standard;
        }
        return { state: '', standard: '', standardName: '', standardCategory: '' };
    }

    getStartingResourceOrQuiz = () => {
        if (this.state.resourceId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.resourcesDict &&
            this.props.studentBaseProps.resourcesDict.hasOwnProperty(this.state.resourceId)
        ) {
            return this.props.studentBaseProps.resourcesDict[this.state.resourceId];
        } else if (this.state.quizId &&
            this.props.studentBaseProps &&
            this.props.studentBaseProps.quizzesDict &&
            this.props.studentBaseProps.quizzesDict.hasOwnProperty(this.state.quizId)
        ) {
            return this.props.studentBaseProps.quizzesDict[this.state.quizId];
        }
        return null;
    }

    getTeacherIds = () => {
        if (!(this.props.studentBaseProps && this.props.studentBaseProps.student)) {
            return [];
        }
        if (this.props.studentBaseProps.student.teacherIds &&
            this.props.studentBaseProps.student.teacherIds.length > 0) {
            return this.props.studentBaseProps.student.teacherIds;
        } else if (this.props.studentBaseProps.student.teacherId) {
            return [this.props.studentBaseProps.student.teacherId];
        }
        return [];
    }

    getTeacherDocId = (teacherId) => {
        let standard = this.getStandard();
        if (!standard) {
            return '';
        }
        if (!this.props.studentBaseProps.activeYear) {
            return '';
        }
        return teacherId + '-' + standard + '-' + this.props.studentBaseProps.activeYear;
    }

    onReady = (event) => {
        // pass
        //console.log("on ready event", event);
    }

    onUpdate = (event) => {
        //console.log("on update event", event);
        if (!(this.props.studentBaseProps && this.props.studentBaseProps.student)) {
            return;
        }
        let resourceId = this.getResourceId();
        if (!resourceId) {
            return;
        }
        // original data for quiz or resource, not progress
        let resourceOrQuiz = this.getStartingResourceOrQuiz();
        if (!resourceOrQuiz) {
            return;
        }
        let docId = this.getResourceProgressDocId();
        if (!docId) {
            return;
        }
        let activeYear = this.props.studentBaseProps.activeYear;
        if (!activeYear) {
            return;
        }

        let progressObj = {
            studentId: this.props.studentBaseProps.student.id,
            teacherIds: this.props.studentBaseProps.student.teacherIds || [],
            teacherId: this.props.studentBaseProps.student.teacherId,
            schoolId: this.props.studentBaseProps.student.schoolId,
            districtId: this.props.studentBaseProps.student.districtId,
            resourceType: this.state.resourceId ? 'resource' : 'quiz',
            quiz: resourceOrQuiz,
            standard: this.getStandard(),
            standards: this.getStandards(),
            year: activeYear,
            updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
            // current state of the quiz based on what has been
            // selected or answered so far
            quizState: event.data,
            quizResults: null,
        };

        if (event.data.survey) {
            progressObj['survey'] = {
                qualitative: event.data.survey,
                completed: true,
            };
        }

        // local update
        this.props.studentBaseProps.onUpdateResourceOrQuizProgressFunc(resourceOrQuiz.id, progressObj);
        // db update
        db.collection(ColType.studentResourceProgress)
            .doc(docId)
            .set(progressObj, { merge: true })
            .then(() => {
                //console.log('quiz submitted successfully')
            })
            .catch((error) => {
                console.log('error submitting quiz', error)
            })
        // teacher progress updates
        /*this.getTeacherIds().forEach(async (teacherId) => {
            let teacherDocId = this.getTeacherDocId(teacherId);
            let teacherProgressDoc = await db.collection(ColType.teacherResourceProgress)
                .doc(teacherDocId)
                .get();
            let studentQuizData = {
                quizState: event.data,
                quizResults: null,
            };
            if (teacherProgressDoc.exists) {
                db.collection(ColType.teacherResourceProgress)
                    .doc(teacherDocId)
                    .update({
                        [`resources.${resourceId}.studentGrades.${this.props.studentBaseProps.student.id}`]: studentQuizData,
                        [`resources.${resourceId}.updateTimeStamp`]: firebase.firestore.FieldValue.serverTimestamp(),
                        updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                    })
                    .then(() => {
                        console.log('teacher progress updated successfully')
                    })
                    .catch((error) => {
                        console.log('error updating teacher progress', error)
                    });
            } else {
                db.collection(ColType.teacherResourceProgress)
                    .doc(teacherDocId)
                    .set({
                        studentId: this.props.studentBaseProps.student.id,
                        teacherId: teacherId,
                        schoolId: this.props.studentBaseProps.student.schoolId,
                        districtId: this.props.studentBaseProps.student.districtId,
                        resourceType: this.state.resourceId ? 'resource' : 'quiz',
                        resourceOrQuizId: resourceId,
                        standard: this.getStandard(),
                        standards: this.getStandards(),
                        year: activeYear,
                        updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                        resources: {
                            [resourceId]: {
                                updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                                studentGrades: {
                                    [this.props.studentBaseProps.student.id]: studentQuizData,
                                }
                            }
                        }
                    }, { merge: true })
                    .then(() => {
                        console.log('teacher progress set successfully')
                    })
                    .catch((error) => {
                        console.log('error setting teacher progress', error)
                    });
            }
        });*/
    }

    onSubmit = (event) => {
        // console.log("on submit event", event);
        if (!(this.props.studentBaseProps && this.props.studentBaseProps.student)) {
            return;
        }
        let resourceId = this.getResourceId();
        if (!resourceId) {
            return;
        }
        // original data for quiz or resource, not progress
        let resourceOrQuiz = this.getStartingResourceOrQuiz();
        if (!resourceOrQuiz) {
            return;
        }
        let docId = this.getResourceProgressDocId();
        if (!docId) {
            return;
        }
        let activeYear = this.props.studentBaseProps.activeYear;
        if (!activeYear) {
            return;
        }
        let standardInfo = this.getStandardNameAndCategory();
        if (!standardInfo || !standardInfo.standard) {
            return;
        }
        //console.log('standard info', standardInfo);

        let progressObj = {
            studentId: this.props.studentBaseProps.student.id,
            teacherIds: this.props.studentBaseProps.student.teacherIds || [],
            teacherId: this.props.studentBaseProps.student.teacherId,
            schoolId: this.props.studentBaseProps.student.schoolId,
            districtId: this.props.studentBaseProps.student.districtId,
            resourceType: this.state.resourceId ? 'resource' : 'quiz',
            quiz: resourceOrQuiz,
            standards: this.getStandards(),
            standard: standardInfo.standard,
            standardName: standardInfo.standardName,
            standardCategory: standardInfo.standardCategory,
            state: standardInfo.state,
            year: activeYear,
            updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
            // current state of the quiz based on what has been
            // selected or answered so far
            quizState: event.data,
            // quiz results, this is the final results of the quiz
            quizResults: event.data.submission.results,
            survey: {
                qualitative: event.data.survey,
                completed: true,
            },
        };

        // local update
        this.props.studentBaseProps.onUpdateResourceOrQuizProgressFunc(resourceOrQuiz.id, progressObj);
        // db update
        db.collection(ColType.studentResourceProgress)
            .doc(docId)
            .set(progressObj, { merge: true })
            .then(() => {
                //console.log('quiz submitted successfully')
            })
            .catch((error) => {
                console.log('error submitting quiz', error)
            })
        // teacher progress updates
        /*
        this.getTeacherIds().forEach(async (teacherId) => {
            let teacherDocId = this.getTeacherDocId(teacherId);
            if (!teacherDocId) {
                return;
            }
            let teacherProgressDoc = await db.collection(ColType.teacherResourceProgress)
                .doc(teacherDocId)
                .get();
            let studentQuizData = {
                quizState: event.data,
                quizResults: event.data.submission.results,
                survey: {
                    qualitative: event.data.survey,
                    completed: true,
                }
            };
            if (teacherProgressDoc.exists) {
                db.collection(ColType.teacherResourceProgress)
                    .doc(teacherDocId)
                    .update({
                        [`resources.${resourceId}.resourceType`]: this.state.resourceId ? 'resource' : 'quiz',
                        [`resources.${resourceId}.studentGrades.${this.props.studentBaseProps.student.id}`]: studentQuizData,
                        [`resources.${resourceId}.updateTimeStamp`]: firebase.firestore.FieldValue.serverTimestamp(),
                        standard: standardInfo.standard,
                        standardName: standardInfo.standardName,
                        standardCategory: standardInfo.standardCategory,
                        state: standardInfo.state,
                        updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                    })
                    .then(() => {
                        console.log('teacher progress updated successfully')
                    })
                    .catch((error) => {
                        console.log('error updating teacher progress', error)
                    });
            } else {
                db.collection(ColType.teacherResourceProgress)
                    .doc(teacherDocId)
                    .set({
                        teacherId: teacherId,
                        schoolId: this.props.studentBaseProps.student.schoolId,
                        districtId: this.props.studentBaseProps.student.districtId,
                        standards: this.getStandards(),
                        standard: standardInfo.standard,
                        standardName: standardInfo.standardName,
                        standardCategory: standardInfo.standardCategory,
                        state: standardInfo.state,
                        year: activeYear,
                        updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                        resources: {
                            [resourceId]: {
                                resourceType: this.state.resourceId ? 'resource' : 'quiz',
                                updateTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
                                studentGrades: {
                                    [this.props.studentBaseProps.student.id]: studentQuizData,
                                }
                            }
                        }
                    }, { merge: true })
                    .then(() => {
                        console.log('teacher progress set successfully')
                    })
                    .catch((error) => {
                        console.log('error setting teacher progress', error)
                    });
            }
        });*/
    }

    render() {
        const weekInQuarter = getWeekInQuarter(this.state.currentWeek);

        return (
            <div>
                <Layout className="content layout-header-mt">
                    <Layout className="mt-0">
                        <Content className="mt-0">
                            <div className="sub-menu-width m-lr-auto mt-4 pl-2 pr-2">
                                {this.state.resourceId &&
                                    this.props.studentBaseProps &&
                                    this.props.studentBaseProps.resourcesDict &&
                                    this.props.studentBaseProps.resourcesDict.hasOwnProperty(this.state.resourceId) &&
                                    this.props.studentBaseProps.studentProgressDict &&
                                    this.props.studentBaseProps.studentProgressDict.hasOwnProperty(this.state.resourceId) ?
                                    <div>
                                        <StudentResource
                                            htmlSource={this.props.studentBaseProps.resourcesDict[this.state.resourceId].doc}
                                            savedState={this.props.studentBaseProps.studentProgressDict[this.state.resourceId] ? {
                                                ...this.props.studentBaseProps.studentProgressDict[this.state.resourceId].quizState,
                                                results: this.props.studentBaseProps.studentProgressDict[this.state.resourceId].quizResults
                                            } : undefined}
                                            onReady={this.onReady}
                                            onUpdate={this.onUpdate}
                                            onSubmit={this.onSubmit}
                                        />
                                    </div>
                                    : ''}

                                {this.state.quizId &&
                                    this.props.studentBaseProps &&
                                    this.props.studentBaseProps.quizzesDict &&
                                    this.props.studentBaseProps.quizzesDict.hasOwnProperty(this.state.quizId) &&
                                    this.props.studentBaseProps.studentProgressDict &&
                                    this.props.studentBaseProps.studentProgressDict.hasOwnProperty(this.state.quizId) ?
                                    <div>
                                        <StudentResource
                                            htmlSource={this.props.studentBaseProps.quizzesDict[this.state.quizId].docs}
                                            savedState={this.props.studentBaseProps.studentProgressDict[this.state.quizId] ? {
                                                ...this.props.studentBaseProps.studentProgressDict[this.state.quizId].quizState,
                                                results: this.props.studentBaseProps.studentProgressDict[this.state.quizId].quizResults
                                            } : undefined}
                                            onReady={this.onReady}
                                            onUpdate={this.onUpdate}
                                            onSubmit={this.onSubmit}
                                        />
                                    </div>
                                    : ''}
                            </div>
                        </Content>
                    </Layout>
                </Layout>
                <CustomFooter />
            </div>
        )
    }
}

export default StudentPracticeResource
